export const NullSelector = {
    kind: "Null",
    test(_) {
        return false;
    },
};
